<template>
  <v-col sm="12" class="pa-0">
    <template>
      <!-- list taxo & total per group -->
      <v-simple-table class="spending-table nav-table" id="taxonomyTable">
        <template v-slot:default>
          <thead>
            <tr class="primary">
              <th class="f-14 white--text text-center" width="11%">Taxonomy</th>
              <th class="f-14 white--text text-center" width="32%">
                Description
              </th>
              <th class="f-14 white--text text-center" width="18%">
                Sign Off Budget
              </th>
              <th class="f-14 white--text text-center" width="18%">
                Current Budget
                <filter-column
                  field="budget"
                  :indexItem="0"
                  @searchColumn="searchCln"
                  @sortBy="sortBy"
                  :listFilter="itemData.filter.budget"
                  @checkColumn="checkColumn"
                  :column-type="true"
                />
              </th>
              <th class="f-14 white--text text-center" width="18%">
                Spending (IO)
                <filter-column
                  field="spending"
                  :indexItem="1"
                  @searchColumn="searchCln"
                  @sortBy="sortBy"
                  :listFilter="itemData.filter.spending"
                  @checkColumn="checkColumn"
                  :column-type="true"
                />
              </th>
              <th class="f-14 white--text text-center" width="15%">
                Budget Usage
              </th>
            </tr>
          </thead>
          <VuePerfectScrollbar
            class="drawer-menu--scroll"
            :settings="scrollSettings"
          >
            <tbody>
              <template class="scrollCus" v-if="itemData.taxonomy.length === 0">
                <tr>
                  <td class="text-center fs-12" colspan="2">
                    <label>No data displayed</label>
                  </td>
                </tr>
              </template>
              <template v-else v-for="item in itemData.taxonomy">
                <template v-if="item.name != 'Couponing/Write offs'">
                  <!-- list taxo -->
                  <tr :key="subItem.code" v-for="subItem in item.listTaxonomy">
                    <td width="11%" class="fs-12">
                      {{ subItem.code || '-' }}
                    </td>
                    <td width="32%" class="fs-12">
                      {{ subItem.desc || '-' }}
                    </td>
                    <td class="text-right fs-12" width="18%">
                      {{
                        subItem.amountSignOff
                          ? idr(subItem.amountSignOff) || '0'
                          : '-'
                      }}
                    </td>
                    <td class="text-right fs-12" width="18%">
                      {{ idr(subItem.amountBudget) || '0' }}
                    </td>
                    <td class="text-right fs-12" width="18%">
                      {{ idr(subItem.amountSpending) || '0' }}
                    </td>
                    <td class="text-right fs-12" width="15%">
                      {{
                        usageBudget(
                          subItem.amountSpending,
                          subItem.amountBudget
                        )
                      }}
                    </td>
                  </tr>
                  <!-- /list taxo -->
                  <!-- total per group -->
                  <tr
                    :key="item.id"
                    class="bgTotal font-weight-bold textblack--text"
                  >
                    <td colspan="2" width="43%">Total {{ item.name }}</td>
                    <td class="text-right" width="18%">
                      {{
                        item.totalSignOff ? idr(item.totalSignOff) || '0' : '-'
                      }}
                    </td>
                    <td class="text-right" width="18%">
                      {{ idr(item.totalBudget) || '0' }}
                    </td>
                    <td class="text-right" width="18%">
                      {{ idr(item.totalSpending) || '0' }}
                    </td>
                    <td class="text-right" width="15%">
                      {{ usageBudget(item.totalSpending, item.totalBudget) }}
                    </td>
                  </tr>
                  <!-- /total per group -->
                </template>
              </template>
            </tbody>
          </VuePerfectScrollbar>
        </template>
      </v-simple-table>
      <!-- total in scope, couponing , total all-->
      <v-col class="grey lighten-2 pa-0" v-if="itemData.taxonomy.length !== 0">
        <!-- total in scope -->
        <v-simple-table
          class="spending-table"
          id="taxonomyTable"
          style="white-space: nowrap"
        >
          <template style="white-space: nowrap" v-slot:default>
            <tbody>
              <tr class="primary white--text">
                <td colspan="2" width="43%">Total in Scope</td>
                <td class="text-right" width="18%">
                  {{
                    itemData.totalInScopeSignOff
                      ? idr(itemData.totalInScopeSignOff) || '0'
                      : '-'
                  }}
                </td>
                <td class="text-right" width="18%">
                  {{ idr(itemData.totalInScopeBudget) || '0' }}
                </td>
                <td class="text-right" width="18%">
                  {{ idr(itemData.totalInScopeSpending) || '0' }}
                </td>
                <td class="text-right" width="15%">
                  {{
                    usageBudget(
                      itemData.totalInScopeSpending,
                      itemData.totalInScopeBudget
                    )
                  }}
                </td>
              </tr>
              <tr style="display: none">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- /total in scope -->

        <!-- couponing -->
        <v-simple-table
          class="spending-table"
          id="taxonomyTable"
          style="white-space: nowrap"
        >
          <template
            style="white-space: nowrap"
            v-slot:default
            v-for="item in itemData.taxonomy"
          >
            <template
              v-if="item.name == 'Couponing/Write offs'"
              style="white-space: nowrap"
            >
              <tbody :key="item.id">
                <tr
                  :key="subItem.code"
                  v-for="subItem in item.listTaxonomy"
                  style="white-space: nowrap"
                >
                  <td width="11%" class="fs-13 font-weight-500">
                    {{ subItem.code || '-' }}
                  </td>
                  <td width="32%" class="fs-13 font-weight-500">
                    {{ subItem.desc || '-' }}
                  </td>
                  <td class="text-right fs-12" width="18%">
                    {{
                      subItem.amountSignOff
                        ? idr(subItem.amountSignOff) || '0'
                        : '-'
                    }}
                  </td>
                  <td class="text-right fs-13 font-weight-500" width="18%">
                    {{ idr(subItem.amountBudget) || '0' }}
                  </td>
                  <td class="text-right fs-13 font-weight-500" width="18%">
                    {{ idr(subItem.amountSpending) || '0' }}
                  </td>
                  <td class="text-right fs-13 font-weight-500" width="15%">
                    {{
                      usageBudget(subItem.amountSpending, subItem.amountBudget)
                    }}
                  </td>
                </tr>
                <tr style="display: none" :key="item.id">
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </template>
        </v-simple-table>
        <!-- /couponing -->

        <!-- total all -->
        <v-simple-table
          class="spending-table"
          id="taxonomyTable"
          style="white-space: nowrap"
        >
          <template style="white-space: nowrap" v-slot:default>
            <tbody>
              <tr class="primary white--text" style="white-space: nowrap">
                <td class="f-14" colspan="2" width="43%">Total</td>
                <td class="f-14 text-right" width="18%">
                  {{ itemData.totalSignOff ? idr(itemData.totalSignOff) : '-' }}
                </td>
                <td class="f-14 text-right" width="18%">
                  {{ idr(itemData.totalBudget) }}
                </td>
                <td class="f-14 text-right" width="18%">
                  {{ idr(itemData.totalSpending) }}
                </td>
                <td class="f-14 text-right" width="15%">
                  {{
                    usageBudget(itemData.totalSpending, itemData.totalBudget)
                  }}
                </td>
              </tr>
              <tr style="display: none">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- /total all -->
      </v-col>
    </template>
    <hr class="hr-line mb-5 mt-5" style="" />
  </v-col>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import filterColumn from '@/components/filterColumn/consolidate';
export default {
  components: {
    VuePerfectScrollbar,
    'filter-column': filterColumn
  },
  props: {
    itemData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 260,
        sortColumn: '',
        sortType: '',
        search: [],
        ceklisSearch: []
      }
    };
  },
  methods: {
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.itemData.listTaxo);
    },
    // searchCln(obj) {
    //   let nameField = obj.fieldName;
    //   let arr = this.itemData.listTaxo;
    //   let valSearch = Array.isArray(obj.value)
    //     ? obj.value.join('|').toLowerCase()
    //     : obj.value.toLowerCase();
    //   this.dataItems = arr.filter(function(a) {
    //     if (a[nameField] !== null) {
    //       if (Array.isArray(obj.value)) {
    //         return obj.value.includes(a[nameField].toString());
    //       } else {
    //         return a[nameField]
    //           .toString()
    //           .toLowerCase()
    //           .match(valSearch);
    //       }
    //     }
    //   });
    // },
    getFiltered(name) {
      if (!name.includes('.')) {
        let dataFiltered = this.itemData.listTaxo.reduce((result, arr) => {
          result[arr[name]] = [...(result[arr[name]] || []), arr];
          return result;
        }, {});
        return Object.keys(dataFiltered);
      }
    },
    searchCln(obj) {
      this.$emit('getSearchBudget', { param: obj, type: 'search' });
    },
    checkColumn(obj) {
      this.$emit('getSearchBudget', { param: obj, type: 'check' });
    },
    sortBy(obj) {
      this.$emit('getSearchBudget', { param: obj, type: 'sort' });
    }
  }
};
</script>
<style>
.spending-table tbody {
  border-bottom: none !important;
  border-left: none !important;
  border-top: none !important;
}
tr:hover {
  background-color: #f5f5f5 !important;
}
</style>
